<script>
import appConfig from '@src/app.config'
export default {
  name: 'AdminInbox',
  data() {
    return {
      items: ['CRMC', 'Veterans'],
      items1: ['Laramie', 'Albany'],
      items2: ['Cheyenne', 'Laramie'],
      items3: ['Approved', 'Denied'],
      clearvalues: [],
    }
  },
}
</script>
<template>
  <v-container fluid>
    <v-layout row wrap mt-4>
      <v-flex xs12 md4 pr-4>
        <v-text-field label="Enter your first name"></v-text-field>
      </v-flex>
      <v-flex xs12 md4 pr-4>
        <v-text-field label="Enter your last name"></v-text-field>
      </v-flex>
      <v-flex xs12 md4>
        <v-text-field label="Search by application ID"></v-text-field>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <v-flex xs12 md4 pr-4>
        <v-select v-bind:items="items" label="Select facility"></v-select>
      </v-flex>
      <v-flex xs12 md4 pr-4>
        <v-select v-bind:items="items1" label="Select County"></v-select>
      </v-flex>
      <v-flex xs12 md4>
        <v-select v-bind:items="items2" label="Select City"></v-select>
      </v-flex>
    </v-layout>

    <v-card-actions class="pb-4">
            <v-btn color="secondary" class="floating--btn" @click="clearvalues" value="btnClear">Clear Selection</v-btn>
        <v-btn color="primary" class="floating--btn" @click="clearvalues" value="btnClear">Clear Selection</v-btn>
          </v-card-actions>
    <v-layout>
      <v-flex xs12>
      <v-data-table :headers="ProfileHeaders" :items="Profile">
        <template slot="items" slot-scope="props">
          <tr>
            <td>
              <v-btn icon href="/views/ApplicantApplication" target="_blank"></v-btn>
            </td>
            <td>{{props.item.imagewithpdf}}</td>
            <td>{{props.item.firstname}}</td>
            <td>{{props.item.lastname}}</td>
            <td>{{props.item.applicationid}}</td>
            <td>{{props.item.facility}}</td>
            <td>{{props.item.county}}</td>
            <td>{{props.item.city}}</td>
            <td>{{props.item.status}}</td>
          </tr>
        </template>
      </v-data-table>
      </v-flex>
    </v-layout>
  </v-container>
</template>
</v-data-table>
</Layout>
</v-container>
</template>
  
